import { useEffect, useState } from 'react';

import { getOSInfo } from './getOSInfo';

export function useOSInfo() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 200);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const os = getOSInfo();

  const isAndroid = os === 'Android OS';
  const isIOS = os === 'iOS';

  return { isLoading, os, isAndroid, isIOS };
}
